<script setup lang="ts"></script>

<template>
  <div>
    <NButton @click="$router.push({ name: 'DemosCreate' })">DemosCreate</NButton>
  </div>
</template>
